import React from "react";
import Skeleton from "react-loading-skeleton";
import StackedStripesLoader from "../../../../components/shared/SkeletonLoaders/StackedStripesLoader";

const DeviceListLoader = ({ cname }) => {
    return (
        <div className={`my-device-list-loader-wrapper ${cname}`}>
            <div className="mydevices-corousel-header">
                <Skeleton className="square-skeleton" />
            </div>
            <div className="mydevices-corousel-details">
                <StackedStripesLoader count = {3} stripeWidths = {['50%',' 70%',' 100%']}/>
            </div>
        </div>
    )
}

export default DeviceListLoader;
